import { useParams } from "react-router";

import { Spinner } from "@prequel/shared-components";

import { useMagicLink } from "@/api/queries/magic-links";
import Connect from "@/containers/Connect";
import NotFound from "@/containers/NotFound";

type MagicLinkProps = {
  prodEnv: boolean;
};
const MagicLink = ({ prodEnv }: MagicLinkProps) => {
  const { orgID, linkID } = useParams();

  const { data: magicLink, isLoading } = useMagicLink({
    orgID: orgID || "",
    linkID: linkID || "",
    isProd: prodEnv,
  });

  if (isLoading) {
    return (
      <div className="flex h-screen w-screen flex-col items-center justify-center bg-gray-50">
        <Spinner message="Loading connection details..." />
      </div>
    );
  } else {
    // If the "host" is populated, assume the link is "good" and show the Connect form
    // Otherwise, display an "expired link" notice
    if (magicLink?.has_been_used) {
      return (
        <NotFound header="Link expired." message="Sorry, the link you provided has already been used." orgID={orgID} />
      );
    } else if (magicLink && orgID && linkID) {
      return <Connect magicLink={magicLink} orgID={orgID} linkID={linkID} prodEnv={prodEnv} />;
    } else {
      return (
        <NotFound header="Not found." message="Sorry, the link you provided either does not exist or has expired." />
      );
    }
  }
};

export default MagicLink;
